import { TFunction } from 'i18next';

const cacheMap = new Map();

const CACHE_MAP_MAX_SIZE = 10;

type TransFN = TFunction<[string, string], undefined>;

export default function vCache<E, H>(key: string, func: (t: TransFN, ...rest: H[]) => E): (t: TransFN, ...rest: H[]) => E {
  return (t: TransFN, ...rest: H[]) => {
    const current = cacheMap.get(key);
    if (current && current.t === t) {
      // console.log('vCache > use old item');
      return current.v;
    }
    const v = func(t, ...rest) as E;
    // console.log('vCache > create new item');
    cacheMap.set(key, { t, v });

    if (cacheMap.size >= CACHE_MAP_MAX_SIZE) {
      // If the size exceeds the limit, remove the first entry
      const firstKey = cacheMap.keys().next().value;
      cacheMap.delete(firstKey);
    }

    return v as E;
  };
}

export { cacheMap };
